import * as React from "react";
import {GranularityType, Toolbar} from "../../../components/toolsbar/Toolbar";
import {Types} from "../../../types/Types";
import {emptyFunction, getGranularities, getTools} from "../charts/common";
import Period = Types.Period;
import {themeDefaultValues, veboxDefaultTheme} from "../../../index";
import {danfossWebDarkGrey} from "../../../styles/global/variables";

interface Props {
    toolbarRef: React.RefObject<Toolbar>;
    translations: any;
    onPanSelected: (...e: any[]) => void;
    onInfoSelected: (...e: any[]) => void;
    onExport: (...e: any[]) => void;
    onBrushEnd: (...e: any[]) => void;
    onTimeExtentChange: (granularity: GranularityType) => void;
    enabled: boolean;
    timelineExtent: Period;
    timelineMaxExtent: Period;
    timelineSelectedPeriod: Period;
    loadingExcel?: boolean;
    height?: number;
}

export class Viewport extends React.Component<Props> {

    public render() {
        return (
            <div
                className={"footer saleContainer"}
                style={{
                    padding: 0,
                    height: "initial",
                    position: "sticky",
                    bottom: 0,
                }}
            >
                {/* Bottom timeline */}
                <div
                    className={"viewport"}
                    style={{
                        height: this.props.height,
                        boxShadow: "none",
                        border: "none",
                    }}
                >
                    <div style={{height: 70, width: "100%", bottom: 0, position: "absolute"}}>
                        {this.props.translations ?
                            <Toolbar
                                ref={this.props.toolbarRef}
                                enabled={this.props.enabled}
                                toolsAvailable={getTools(
                                    this.props.translations,
                                    this.props.onPanSelected,
                                    this.props.onInfoSelected,
                                    this.props.onExport,
                                )}
                                onBrush={this.props.onBrushEnd}
                                retrieveData={this.middleRetrieveData}
                                timelineExtent={this.props.timelineExtent}
                                timelineMaxExtent={this.props.timelineMaxExtent}
                                timelineSelectedPeriod={this.props.timelineSelectedPeriod}
                                granularities={getGranularities(this.props.translations)}
                                texts={this.props.translations}
                                loadingExcel={this.props.loadingExcel}
                            /> : null}
                    </div>
                </div>
            </div>
        );
    }

    private middleRetrieveData = (g) => {
        this.props.onTimeExtentChange(g);
    }
}
